// Province-based pricing utility for TuGo CANADIAN plans
// This utility applies different pricing factors based on origin province and destination

const PROVINCE_FACTORS_NON_USA = {
  default: 1.0,
  AB: 0.802, // Ontario 대비 -19.8%
  SK: 0.802,
  MB: 0.802,
  BC: 0.804, // Ontario 대비 -19.6%
  YT: 0.804,
  NT: 0.804,
};

const PROVINCE_FACTORS_USA = {
  default: 1.0,
  AB: 0.9682, // Ontario 대비 -3.18%
  SK: 0.9682,
  MB: 0.9682,
  BC: 0.8483, // Ontario 대비 -15.17%
  YT: 0.8483,
  NT: 0.8483,
};

/**
 * Get province pricing factor based on origin province and destination
 * @param {string} originProvince - Province code (e.g., 'ON', 'AB', 'BC')
 * @param {string} destinationCountryOrType - Destination country or type (e.g., 'USA', 'US', 'United States', 'World', etc.)
 * @returns {number} Pricing factor (1.0 for Ontario base, < 1.0 for discounts)
 */
export function getProvinceFactor(originProvince, destinationCountryOrType) {
  if (!originProvince) return 1.0;

  // 미국 여행(USA)은 기존 요율 그대로
  if (
    destinationCountryOrType === 'USA' ||
    destinationCountryOrType === 'US' ||
    destinationCountryOrType === 'United States'
  ) {
    return PROVINCE_FACTORS_USA[originProvince] || PROVINCE_FACTORS_USA.default;
  }

  // 미국 외 여행(Other than USA): 주별 할인율 적용
  return PROVINCE_FACTORS_NON_USA[originProvince] || PROVINCE_FACTORS_NON_USA.default;
}

/**
 * Apply province-based pricing to base premium
 * @param {number} basePremium - TuGo API에서 온 원래 보험료(할인 전)
 * @param {string} originProvince - Province code (e.g., 'ON', 'AB', 'BC')
 * @param {string} destinationCountryOrType - Destination country or type (e.g., 'USA', 'World', etc.)
 * @returns {Object} Object containing factor and adjustedPremium
 */
export function applyProvincePricing(basePremium, originProvince, destinationCountryOrType) {
  const factor = getProvinceFactor(originProvince, destinationCountryOrType);
  const adjustedPremium = Math.round(basePremium * factor * 100) / 100;
  
  return {
    factor,
    adjustedPremium,
  };
}

